module.exports = __webpack_public_path__ + "img/Easel Top.757b12bd.png";